import { call, put, take } from 'redux-saga/effects';
import { getAllMediaDevices } from '../../opentok/helpers/utils';
import {
  DEVICE_PERMISSION_TYPES,
  hasDevicePermissions,
} from '../../opentok/helpers/devicePermissionHelper';
import {
  DEVICE_PERMISSION_ACTION_TYPES,
  devicePermissionActions,
} from '../devicePermissions';
import { asyncOpentokLoader } from '../../opentok/hooks/useOTScriptLoad';

const { REQUEST, DENIED } = DEVICE_PERMISSION_TYPES;

function loadScripts() {
  return new Promise(resolve => asyncOpentokLoader(() => resolve()));
}

export function* checkPermission(invitable) {
  yield call(loadScripts);
  const devices = yield call(getAllMediaDevices);
  const hasPermission = hasDevicePermissions(devices);
  const audio = devices.some(device => device.kind === 'audioInput');
  const video = devices.some(device => device.kind === 'videoInput');

  if (hasPermission) {
    return true;
  }

  yield put(devicePermissionActions.open({ type: REQUEST, invitable }));
  try {
    const stream = yield call(() =>
      navigator.mediaDevices.getUserMedia({ audio, video }),
    );
    if (stream.getTracks) {
      stream.getTracks().forEach(track => track.stop());
    }
    yield put(devicePermissionActions.close());
    return true;
  } catch (error) {
    yield put(devicePermissionActions.open({ type: DENIED, invitable }));
    yield take(DEVICE_PERMISSION_ACTION_TYPES.GRAND_PERMISSION);
    yield put(devicePermissionActions.close());
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/checkPermission.js